import './style.scss';
import { getAIUsage } from 'actions/adminActions';
import { getLocalization } from 'global/global';
import * as React from 'react';
import { useState } from 'react';
import { Alert, DropdownButton, Table } from 'react-bootstrap';
import { AiUserUsageInterface } from 'Interfaces/AiUserUsageInterface';

interface Props {
  visible: boolean;
}

export default function Usage(props: Props) {

  const [usage, setUsage] = useState<null | AiUserUsageInterface[]>(null);
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (!usage && !loading && props.visible) {
      setLoading(true);
      getAIUsage().then(json => {
        if (Array.isArray(json)) {
          setUsage(json);
        } else {
          setUsage([]);
        }
      }).catch(() => {
        setUsage([]);
      });
    }
  });

  if (!props.visible) {
    return null;
  }
  return (
    <DropdownButton
      id={'usage=btn'}
      title={getLocalization('aiUsagePerUser')}
      variant={'primary'}
      size={'sm'}
      className={'ai-usage-dropdown'}
    >
      <div className="ai-usage-table">
        {usage ? (
          <Table
            striped={true}
            bordered={true}
            hover={true}
          >
            <thead>
              <tr>
                <th>{getLocalization('user')}</th>
                <th>{getLocalization('usage')}</th>
              </tr>
            </thead>
            <tbody>
              {usage?.map(u => (
                <tr key={`ai-usage-${u.userName}-${u.usage}`}>
                  <td>{u.userName}</td>
                  <td>${u.usage}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <Alert>{getLocalization('noUsageYet')}</Alert>
        )}
      </div>
    </DropdownButton>
  );
}
